import { render, staticRenderFns } from "./badge-list.html?vue&type=template&id=7a3c2977&scoped=true&"
import script from "./badge-list.js?vue&type=script&lang=js&"
export * from "./badge-list.js?vue&type=script&lang=js&"
import style0 from "./badge-list.scss?vue&type=style&index=0&id=7a3c2977&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3c2977",
  null
  
)

export default component.exports